import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import ReviewTopic from "../pages/review/topic/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "review/topic/:topicId", element: <ReviewTopic /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;